import { useLayoutEffect } from 'react';
import { connect } from '@atlassian/jira-react-redux';
import mapStateToProps from './query';
import type { Props } from './types';

const EmitLoadComplete = ({ callback, timelineRange, timelineExportWidth }: Props) => {
	useLayoutEffect(() => {
		callback();
	}, [callback, timelineExportWidth, timelineRange.start, timelineRange.end]);
	return null;
};

export default connect(mapStateToProps, {})(EmitLoadComplete);
